const DEFAULT_RANGE_DAYS = 30;

/** 日付だけを渡し、日本時間の日境界への変換はサーバー側に任せる。 */
const toDateInput = (date: Date): string =>
  new Date(date.getTime() + 9 * 60 * 60 * 1000).toISOString().slice(0, 10);

/**
 * 既定の集計期間（直近30日）。呼び出しの都度「今日」を基準に計算する。
 * モジュール読み込み時に固定すると、開きっぱなしのタブでは期間が古いまま、
 * 直近の登録が黙って集計から欠ける。
 */
export const buildDefaultRange = (): { from: string; to: string } => ({
  from: toDateInput(
    new Date(Date.now() - DEFAULT_RANGE_DAYS * 24 * 60 * 60 * 1000),
  ),
  to: toDateInput(new Date()),
});
